import { render } from "./ModalCreate.vue?vue&type=template&id=1803b36d&scoped=true"
import script from "./ModalCreate.vue?vue&type=script&lang=js"
export * from "./ModalCreate.vue?vue&type=script&lang=js"

import "./ModalCreate.vue?vue&type=style&index=0&id=1803b36d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1803b36d"]])

export default __exports__